import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  viewBox: "0 0 24.4268 45.1"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "nonzero",
      d: "m19.7969 0 .2203.6996 4 12.7.4096 1.3004-11.1638-.001v28.4l7.8004.001v2h-17.7v-2l7.8996-.001v-28.4L0 14.7l.4096-1.3004 4-12.7L4.6299 0h15.167Zm-1.4675 2H6.0964l-3.371 10.7h18.975L18.3294 2Z"
    }, null, -1)
  ])))
}
export default { render: render }